import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, renderSlot as _renderSlot, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-backdrop"
}

import { TeleportProps } from "vue";
interface BackdropModalProps {
  enabled: boolean;
  element?: TeleportProps["to"];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BackdropModal',
  props: {
    enabled: { type: Boolean, default: false },
    element: { default: "body" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, {
      to: _ctx.element,
      disabled: !_ctx.enabled
    }, [
      _createVNode(_Transition, { name: "pop" }, {
        default: _withCtx(() => [
          (_ctx.enabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 8, ["to", "disabled"])),
    (_openBlock(), _createBlock(_Teleport, {
      to: _ctx.element,
      disabled: !_ctx.enabled
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 8, ["to", "disabled"]))
  ], 64))
}
}

})